import { render, staticRenderFns } from "./AddOrUpdatePresentingComplaintModal.vue?vue&type=template&id=21cbe31b&"
import script from "./AddOrUpdatePresentingComplaintModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdatePresentingComplaintModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdatePresentingComplaintModal.vue?vue&type=style&index=0&id=21cbe31b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports